import React from 'react';
import { useTheme } from '@mui/material/styles';
import { formatDateSimple } from 'utils/formatDate';
import { CardContainer, CardLine, MiddleSection, StatusBadge, StatusText, TextOpacity } from 'v3/shared/components/Cards/InstallmentCard/styles';
import { InstallmentStatusEnum } from 'v3/data/store/installments/enum';
import { IInstallment } from 'v3/services/interfaces/response';
import { amountFormatter } from 'utils/formatters';
import { BodySmallRegularStyled } from 'v3/shared/typography/BodySmall/styles';
import { LabelSmallStyled } from 'v3/shared/typography/LabelSmall/styles';
import { SubtitleMediumBoldStyled } from 'v3/shared/typography/SubtitleMedium/styles';


const getStatusDisplay = (status: InstallmentStatusEnum, theme: any) => {
  let text = '';
  let textColor = theme.palette.text.primary;
  let background = theme.palette.text.primary;

  switch (status) {
    case InstallmentStatusEnum.LATE:
      text = 'ATRASADA';
      textColor = theme.palette.common.white;
      background = theme.palette.tertiary.light;
      break;
    case InstallmentStatusEnum.PENDING_PAYMENT:
      text = 'A VENCER';
      textColor = theme.palette.common.black;
      background = theme.palette.warning.light;
      break;
    case InstallmentStatusEnum.PAID:
      text = 'PAGO';
      textColor = theme.palette.common.white;
      background = theme.palette.success.main;
      break;
    default:
      text = 'DESCONHECIDO';
      textColor = theme.palette.text.primary;
      background = theme.palette.grey[500];
  }
  return { text, background, textColor };
};

interface InstallmentCardProps {
  installment: IInstallment;
  totalInstallments: number;
}

export const InstallmentCard: React.FC<InstallmentCardProps> = ({ installment, totalInstallments }) => {
  const theme = useTheme();
  const { text: statusText, background: background, textColor: textColor } = getStatusDisplay(installment.paymentStatus, theme);

  let updatedValueLabel: string;
  if (installment.paymentStatus === InstallmentStatusEnum.PENDING_PAYMENT) {
    updatedValueLabel = 'Valor com desconto';
  } else if (installment.paymentStatus === InstallmentStatusEnum.LATE) {
    updatedValueLabel = 'Valor atualizado';
  } else {
    updatedValueLabel = 'Valor a pagar';
  }

  return (
    <CardContainer>
      <CardLine>
        <BodySmallRegularStyled>
          Parcela {installment.number} de {totalInstallments}
        </BodySmallRegularStyled>
        <StatusBadge background={background} textColor={textColor}>
          <StatusText>
            {statusText}
          </StatusText>
        </StatusBadge>
      </CardLine>
      <MiddleSection>
        <CardLine>
          <LabelSmallStyled>
            Data de vencimento
          </LabelSmallStyled>
          <BodySmallRegularStyled>
            {formatDateSimple(installment.dueDate)}
          </BodySmallRegularStyled>
        </CardLine>

        <CardLine>
          <LabelSmallStyled>
            Valor da parcela
          </LabelSmallStyled>
          <BodySmallRegularStyled>
            {amountFormatter(installment.amount)}
          </BodySmallRegularStyled>
        </CardLine>
      </MiddleSection>
      <CardLine>
        <LabelSmallStyled>
          {updatedValueLabel}
        </LabelSmallStyled>
        <SubtitleMediumBoldStyled>
          {amountFormatter(installment.presentAmount)}
        </SubtitleMediumBoldStyled>
      </CardLine>

      {installment.paymentStatus === InstallmentStatusEnum.PENDING_PAYMENT && (
        <TextOpacity>
          <LabelSmallStyled>
          Pagamentos antecipados das parcelas contam com desconto aplicado.
        </LabelSmallStyled>
        </TextOpacity>
      )}
    </CardContainer>
  );
};